import { render, staticRenderFns } from "./cart_item_upsell.vue?vue&type=template&id=544dea26"
import script from "./cart_item_upsell.vue?vue&type=script&lang=js"
export * from "./cart_item_upsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544dea26')) {
      api.createRecord('544dea26', component.options)
    } else {
      api.reload('544dea26', component.options)
    }
    module.hot.accept("./cart_item_upsell.vue?vue&type=template&id=544dea26", function () {
      api.rerender('544dea26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/cart_item_upsell.vue"
export default component.exports